<template>
  <div class="admin-container">
    <!-- 侧边栏 -->
    <aside class="sidebar">
      <div class="sidebar-header">
        <h3>管理后台</h3>
      </div>
      <nav class="sidebar-nav">
        <ul>
          <li class="nav-item" :class="{ active: activeMenu === 'news' }">
            <a href="javascript:void(0)" @click="activeMenu = 'news'">
              <i class="el-icon-document"></i>
              <span>新闻管理</span>
            </a>
          </li>
          <li class="nav-item" :class="{ active: activeMenu === 'banners' }">
            <a href="javascript:void(0)" @click="activeMenu = 'banners'">
              <i class="el-icon-picture-outline"></i>
              <span>轮播图管理</span>
            </a>
          </li>
          <li class="nav-item" :class="{ active: activeMenu === 'media' }">
            <a href="javascript:void(0)" @click="activeMenu = 'media'">
              <i class="el-icon-picture"></i>
              <span>媒体库</span>
            </a>
          </li>
          <li class="nav-item" :class="{ active: activeMenu === 'users' }">
            <a href="javascript:void(0)" @click="activeMenu = 'users'">
              <i class="el-icon-user"></i>
              <span>用户管理</span>
            </a>
          </li>
          <li class="nav-item" :class="{ active: activeMenu === 'settings' }">
            <a href="javascript:void(0)" @click="activeMenu = 'settings'">
              <i class="el-icon-setting"></i>
              <span>系统设置</span>
            </a>
          </li>
        </ul>
      </nav>
      <div class="sidebar-footer">
        <button class="logout-btn" @click="handleLogout">
          <i class="el-icon-switch-button"></i>
          <span>退出登录</span>
        </button>
      </div>
    </aside>

    <!-- 主内容区域 -->
    <main class="main-content">
      <!-- 顶部导航栏 -->
      <header class="main-header">
        <div class="header-left">
          <h1>{{ getPageTitle() }}</h1>
        </div>
        <div class="header-right">
          <div class="user-info">
            <span class="username">管理员</span>
          </div>
        </div>
      </header>

      <!-- 内容区域 -->
      <div class="content-wrapper">
        <!-- 新闻管理页面 -->
        <div v-if="activeMenu === 'news'" class="news-management">
          <div class="news-list-section">
            <div class="section-header">
              <h2>新闻列表</h2>
              <el-button type="primary" @click="showAddNewsDialog = true">
                <i class="el-icon-plus"></i> 添加新闻
              </el-button>
            </div>

            <!-- 搜索和筛选 -->
            <div class="search-filter">
              <el-input
                v-model="searchQuery"
                placeholder="搜索新闻标题"
                prefix-icon="el-icon-search"
                class="search-input"
                @keyup.enter.native="fetchNews"
              ></el-input>
              <el-select
                v-model="statusFilter"
                placeholder="筛选状态"
                class="filter-select"
                @change="fetchNews"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="待审核" value="pending_review"></el-option>
                <el-option label="已发布" value="published"></el-option>
                <el-option label="草稿" value="draft"></el-option>
                <el-option label="已拒绝" value="rejected"></el-option>
              </el-select>
            </div>

            <!-- 新闻列表 -->
            <el-table :data="newsList" style="width: 100%" border>
              <el-table-column label="封面" width="120">
                <template #default="scope">
                  <el-image
                    v-if="scope.row.image"
                    :src="IMAGE_BASE_URL + scope.row.image"
                    fit="cover"
                    style="width: 100px; height: 60px; border-radius: 4px"
                    :preview-src-list="[IMAGE_BASE_URL + scope.row.image]"
                  ></el-image>
                  <span v-else>无图片</span>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="标题" min-width="200"></el-table-column>
              <el-table-column prop="summary" label="摘要" min-width="300"></el-table-column>
              <el-table-column prop="author" label="作者" width="120"></el-table-column>
              <el-table-column prop="date" label="发布日期" width="180" :formatter="formatDate"></el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template #default="scope">
                  <el-tag :type="getStatusTagType(scope.row.status)">
                    {{ getStatusText(scope.row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="viewCount" label="浏览量" width="100"></el-table-column>
              <el-table-column label="操作" width="280" fixed="right">
                <template #default="scope">
                  <el-button type="primary" size="small" @click="editNews(scope.row)">
                    <i class="el-icon-edit"></i> 编辑
                  </el-button>
                  <el-button
                    v-if="scope.row.status === 'draft'"
                    type="success"
                    size="small"
                    @click="submitForReview(scope.row.id)"
                  >
                    <i class="el-icon-check"></i> 提交审核
                  </el-button>
                  <el-button
                    v-if="scope.row.status === 'pending_review'"
                    type="success"
                    size="small"
                    @click="approveNews(scope.row.id)"
                  >
                    <i class="el-icon-check"></i> 审核通过
                  </el-button>
                  <el-button
                    v-if="scope.row.status === 'pending_review'"
                    type="warning"
                    size="small"
                    @click="rejectNews(scope.row.id)"
                  >
                    <i class="el-icon-close"></i> 拒绝
                  </el-button>
                  <el-button type="danger" size="small" @click="deleteNews(scope.row.id)">
                    <i class="el-icon-delete"></i> 删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination">
              <el-pagination
                layout="total, prev, pager, next"
                :total="totalNews"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handlePageChange"
              ></el-pagination>
            </div>
          </div>
        </div>

        <!-- 用户管理页面 -->
        <div v-else-if="activeMenu === 'users'" class="users-management">
          <div class="users-list-section">
            <div class="section-header">
              <h2>用户列表</h2>
              <el-button type=" primary" @click="showAddUserDialog = true">
                <i class="el-icon-plus"></i> 添加用户
              </el-button>
            </div>
            <div class="search-filter">
              <el-input
                v-model="usersSearchQuery"
                placeholder="搜索用户名或邮箱"
                prefix-icon="el-icon-search"
                class="search-input"
                @keyup.enter.native="fetchUsers"
              ></el-input>
            </div>
            <el-table :data="usersList" style="width: 100%" border>
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column prop="username" label="用户名" min-width="150"></el-table-column>
              <el-table-column prop="email" label="邮箱" min-width="200"></el-table-column>
              <el-table-column prop="createdAt" label="创建时间" width="180" :formatter="formatDate"></el-table-column>
              <el-table-column label="操作" width="250" fixed="right">
                <template #default="scope">
                  <el-button type="primary" size="small" @click="editUser(scope.row)">
                    <i class="el-icon-edit"></i> 编辑
                  </el-button>
                  <el-button type="success" size="small" @click="manageUserRoles(scope.row)">
                    <i class="el-icon-setting"></i> 权限管理
                  </el-button>
                  <el-button type="danger" size="small" @click="deleteUser(scope.row.id)">
                    <i class="el-icon-delete"></i> 删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination
                layout="total, prev, pager, next"
                :total="totalUsers"
                :page-size="usersPageSize"
                :current-page="usersCurrentPage"
                @current-change="handleUsersPageChange"
              ></el-pagination>
            </div>
          </div>
        </div>

        <!-- 媒体库管理页面 -->
        <div v-else-if="activeMenu === 'media'" class="media-management">
          <div class="media-list-section">
            <div class="section-header">
              <h2>媒体库</h2>
              <el-button type="primary" @click="showUploadDialog = true">
                <i class="el-icon-plus"></i> 上传媒体
              </el-button>
            </div>
            <div class="search-filter">
              <el-input
                v-model="mediaSearchQuery"
                placeholder="搜索文件名"
                prefix-icon="el-icon-search"
                class="search-input"
                @keyup.enter.native="fetchMedia"
              ></el-input>
            </div>
            <el-table :data="mediaList" style="width: 100%" border>
              <el-table-column label="预览" width="80">
                <template #default="scope">
                  <el-image
                    v-if="scope.row.url"
                    :src="IMAGE_BASE_URL + scope.row.url"
                    style="width: 60px; height: 60px; object-fit: cover"
                    :preview-src-list="[IMAGE_BASE_URL + scope.row.url]"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="filename" label="文件名" min-width="150"></el-table-column>
              <el-table-column prop="originalName" label="原始文件名" min-width="200"></el-table-column>
              <el-table-column prop="size" label="大小" width="100">
                <template #default="scope">
                  {{ (scope.row.size / 1024).toFixed(2) }} KB
                </template>
              </el-table-column>
              <el-table-column prop="uploadDate" label="上传时间" width="180" :formatter="formatDate"></el-table-column>
              <el-table-column label="操作" width="180" fixed="right">
                <template #default="scope">
                  <el-button type="primary" size="small" @click="selectMedia(scope.row)">
                    <i class="el-icon-check"></i> 选择
                  </el-button>
                  <el-button type="danger" size="small" @click="deleteMedia(scope.row.id)">
                    <i class="el-icon-delete"></i> 删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination
                layout="total, prev, pager, next"
                :total="totalMedia"
                :page-size="mediaPageSize"
                :current-page="mediaCurrentPage"
                @current-change="handleMediaPageChange"
              ></el-pagination>
            </div>
          </div>
        </div>

        <!-- 轮播图管理页面 -->
        <div v-else-if="activeMenu === 'banners'" class="banners-management">
          <div class="banners-list-section">
            <div class="section-header">
              <h2>轮播图管理</h2>
              <el-button type="primary" @click="showAddBannerDialog = true">
                <i class="el-icon-plus"></i> 添加轮播图
              </el-button>
            </div>
            <div class="search-filter">
              <el-input
                v-model="bannersSearchQuery"
                placeholder="搜索轮播图标题"
                prefix-icon="el-icon-search"
                class="search-input"
                @keyup.enter.native="fetchBanners"
              ></el-input>
              <el-select
                v-model="bannersStatusFilter"
                placeholder="筛选状态"
                class="filter-select"
                @change="fetchBanners"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="激活" value="active"></el-option>
                <el-option label="禁用" value="inactive"></el-option>
              </el-select>
            </div>
            <el-table :data="bannersList" style="width: 100%" border>
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column prop="title" label="标题" min-width="200"></el-table-column>
              <el-table-column prop="subtitle" label="副标题" min-width="150"></el-table-column>
              <el-table-column label="图片" width="120">
                <template #default="scope">
                  <el-image
                    v-if="scope.row.image"
                    :src="IMAGE_BASE_URL + scope.row.image"
                    style="width: 80px; height: 40px; object-fit: cover"
                    :preview-src-list="[IMAGE_BASE_URL + scope.row.image]"
                  ></el-image>
                  <span v-else>无图片</span>
                </template>
              </el-table-column>
              <el-table-column prop="order" label="排序" width="80"></el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template #default="scope">
                  <el-tag :type="scope.row.status === 'active' ? 'success' : 'warning'">
                    {{ scope.row.status === 'active' ? '激活' : '禁用' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createdAt" label="创建时间" width="180" :formatter="formatDate"></el-table-column>
              <el-table-column label="操作" width="180" fixed="right">
                <template #default="scope">
                  <el-button type="primary" size="small" @click="editBanner(scope.row)">
                    <i class="el-icon-edit"></i> 编辑
                  </el-button>
                  <el-button type="danger" size="small" @click="deleteBanner(scope.row.id)">
                    <i class="el-icon-delete"></i> 删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination
                layout="total, prev, pager, next"
                :total="totalBanners"
                :page-size="bannersPageSize"
                :current-page="bannersCurrentPage"
                @current-change="handleBannersPageChange"
              ></el-pagination>
            </div>
          </div>
        </div>

        <!-- 系统设置页面 -->
        <div v-else-if="activeMenu === 'settings'" class="settings-management">
          <h2>系统设置功能开发中...</h2>
        </div>

        <!-- 所有弹窗放在条件渲染页面之后 -->

        <!-- 添加/编辑新闻弹窗 -->
        <el-dialog
          :title="newsForm.id ? '编辑新闻' : '添加新闻'"
          :visible.sync="showAddNewsDialog"
          width="80%"
          :close-on-click-modal="false"
        >
          <el-form :model="newsForm" :rules="newsRules" ref="newsForm" label-width="100px">
            <el-form-item prop="title">
              <el-input v-model="newsForm.title" placeholder="请输入新闻标题"></el-input>
            </el-form-item>
            <el-form-item prop="summary">
              <el-input
                v-model="newsForm.summary"
                type="textarea"
                placeholder="请输入新闻摘要"
                :rows="3"
              ></el-input>
            </el-form-item>
            <el-form-item prop="content">
              <el-input
                v-model="newsForm.content"
                type="textarea"
                placeholder="请输入新闻内容"
                :rows="10"
              ></el-input>
            </el-form-item>
            <el-form-item prop="author">
              <el-input v-model="newsForm.author" placeholder="请输入作者"></el-input>
            </el-form-item>
            <el-form-item prop="status">
              <el-select v-model="newsForm.status" placeholder="请选择状态">
                <el-option label="草稿" value="draft"></el-option>
                <el-option label="已发布" value="published"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="新闻图片">
              <div class="image-upload-section">
                <el-button type="primary" @click="selectNewsImage">
                  <i class="el-icon-upload"></i> 选择图片
                </el-button>
                <el-button
                  v-if="newsForm.image"
                  type="danger"
                  @click="removeNewsImage"
                  style="margin-left: 10px"
                >
                  <i class="el-icon-delete"></i> 移除图片
                </el-button>
              </div>
              <div class="image-preview" v-if="newsForm.image">
                <el-image
                  :src="IMAGE_BASE_URL + newsForm.image"
                  fit="cover"
                  style="width: 300px; height: 200px; margin-top: 10px; border: 1px solid #eee; border-radius: 4px"
                ></el-image>
              </div>
              <div class="image-hint" v-if="!newsForm.image">
                <small>请选择一张图片作为新闻封面</small>
              </div>
            </el-form-item>
            <el-form-item prop="date">
              <el-date-picker
                v-model="newsForm.date"
                type="datetime"
                placeholder="选择发布日期"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showAddNewsDialog = false">取消</el-button>
            <el-button type="primary" @click="submitNewsForm">提交</el-button>
          </span>
        </el-dialog>

        <!-- 添加/编辑用户弹窗 -->
        <el-dialog
          :title="userForm.id ? '编辑用户' : '添加用户'"
          :visible.sync="showAddUserDialog"
          width="50%"
          :close-on-click-modal="false"
        >
          <el-form :model="userForm" :rules="userRules" ref="userForm" label-width="100px">
            <el-form-item prop="username">
              <el-input v-model="userForm.username" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item prop="email">
              <el-input v-model="userForm.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="userForm.password"
                type="password"
                placeholder="请输入密码"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item prop="passwordConfirm">
              <el-input
                v-model="userForm.passwordConfirm"
                type="password"
                placeholder="请确认密码"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showAddUserDialog = false">取消</el-button>
            <el-button type="primary" @click="submitUserForm">提交</el-button>
          </span>
        </el-dialog>

        <!-- 权限管理弹窗 -->
        <el-dialog
          :title="`${currentUser?.username}的权限管理`"
          :visible.sync="showRoleManagementDialog"
          width="50%"
          :close-on-click-modal="false"
          @close="resetRoleManagement"
        >
          <el-form :model="currentUser || {}" ref="roleForm" label-width="100px">
            <el-form-item label="用户名">
              <el-input v-model="(currentUser || {}).username" readonly></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="(currentUser || {}).email" readonly></el-input>
            </el-form-item>
            <el-form-item label="用户角色">
              <el-checkbox-group v-model="selectedRoles">
                <el-checkbox
                  v-for="role in allRoles"
                  :key="role.id"
                  :label="role.id"
                  class="role-checkbox"
                >
                  {{ role.display_name }} ({{ role.name }})
                </el-checkbox>
              </el-checkbox-group>
              <div class="role-description" v-if="selectedRoles.length === 0">
                请为用户选择至少一个角色
              </div>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showRoleManagementDialog = false">取消</el-button>
            <el-button type="primary" @click="saveUserRoles">保存权限</el-button>
          </span>
        </el-dialog>

        <!-- 上传媒体弹窗 -->
        <el-dialog
          title="上传媒体"
          :visible.sync="showUploadDialog"
          width="50%"
          :close-on-click-modal="false"
        >
          <el-form :model="mediaForm" :rules="mediaRules" ref="mediaForm" label-width="100px">
            <el-form-item prop="file">
              <el-upload
                class="upload-demo"
                :action="''"
                :http-request="handleUpload"
                :auto-upload="false"
                :show-file-list="true"
                :file-list="mediaFileList"
                accept=".jpg,.jpeg,.png,.mp3"
                :on-change="handleFileChange"
                :on-remove="handleFileRemove"
              >
                <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item prop="description">
              <el-input
                v-model="mediaForm.description"
                type="textarea"
                placeholder="请输入媒体描述"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showUploadDialog = false">取消</el-button>
            <el-button type="primary" @click="submitMediaUpload">确认上传</el-button>
          </span>
        </el-dialog>

        <!-- 媒体选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="showMediaSelectDialog"
          width="80%"
          :close-on-click-modal="false"
        >
          <div class="search-filter" style="margin-bottom: 20px;">
            <el-input
              v-model="mediaSearchQuery"
              placeholder="搜索文件名"
              prefix-icon="el-icon-search"
              class="search-input"
              style="width: 300px;"
              @keyup.enter.native="fetchMedia"
            ></el-input>
          </div>
          <div class="media-grid" v-if="mediaList.length > 0">
            <div
              class="media-item"
              v-for="media in mediaList"
              :key="media.id"
              :class="{ 'media-item-selected': selectedMedia && selectedMedia.id === media.id }"
              @click="selectMediaForNews(media)"
            >
              <el-image
                :src="IMAGE_BASE_URL + media.url"
                fit="cover"
                style="width: 100%; height: 120px;"
              ></el-image>
              <div class="media-item-name">{{ media.originalName }}</div>
              <div class="media-item-check" v-if="selectedMedia && selectedMedia.id === media.id">
                <i class="el-icon-check"></i>
              </div>
            </div>
          </div>
          <div class="empty-media" v-else>
            <p>暂无图片，请先上传图片到媒体库</p>
          </div>
          <div class="pagination" style="margin-top: 20px;">
            <el-pagination
              layout="total, prev, pager, next"
              :total="totalMedia"
              :page-size="mediaPageSize"
              :current-page="mediaCurrentPage"
              @current-change="handleMediaPageChange"
            ></el-pagination>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showMediaSelectDialog = false">取消</el-button>
            <el-button type="primary" @click="confirmMediaSelection" :disabled="!selectedMedia"
              >确认选择</el-button
            >
          </span>
        </el-dialog>
      </div>
    </main>
  </div>
</template>

<script>
import { newsAPI, userAPI, mediaAPI, bannerAPI, roleAPI } from '../services/api';
import { IMAGE_BASE_URL } from '@/services/api';
export default {
  name: 'Admin',
  data() {
    return {
      activeMenu: 'news',
      IMAGE_BASE_URL,
      showAddNewsDialog: false,
      searchQuery: '',
      statusFilter: '',
      currentPage: 1,
      pageSize: 10,
      totalNews: 10,
      newsList: [
        {
          id: 1,
          title: '中政量化研究院发布2026年量化投资策略展望',
          summary: '中政量化研究院今日发布2026年量化投资策略展望，预计明年市场将呈现结构化行情，AI驱动的量化策略将成为主流。',
          content: '中政量化研究院今日发布2026年量化投资策略展望，预计明年市场将呈现结构化行情，AI驱动的量化策略将成为主流。',
          author: '管理员',
          status: 'published',
          date: new Date(),
          viewCount: 100
        },
        {
          id: 2,
          title: '中政量化与国内知名高校达成战略合作',
          summary: '中政量化研究院宣布与国内某知名高校达成战略合作，共同开展人工智能在量化投资领域的研究与应用。',
          content: '中政量化研究院宣布与国内某知名高校达成战略合作，共同开展人工智能在量化投资领域的研究与应用。',
          author: '管理员',
          status: 'published',
          date: new Date(),
          viewCount: 80
        }
      ],
      newsForm: {
        title: '',
        summary: '',
        content: '',
        author: '',
        status: 'draft',
        date: new Date(),
        image: ''
      },
      newsRules: {
        title: [
          { required: true, message: '请输入新闻标题', trigger: 'blur' },
          { max: 200, message: '新闻标题不能超过200个字符', trigger: 'blur' }
        ],
        summary: [
          { required: true, message: '请输入新闻摘要', trigger: 'blur' },
          { max: 500, message: '新闻摘要不能超过500个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入新闻内容', trigger: 'blur' }
        ],
        author: [
          { required: true, message: '请输入作者', trigger: 'blur' }
        ]
      },
      // 用户管理相关数据
      usersList: [],
      totalUsers: 0,
      usersCurrentPage: 1,
      usersPageSize: 10,
      usersSearchQuery: '',
      showAddUserDialog: false,
      // 权限管理相关数据
      showRoleManagementDialog: false,
      currentUser: null,
      userRoles: [],
      allRoles: [],
      selectedRoles: [],
      userForm: {
        username: '',
        email: '',
        password: '',
        passwordConfirm: ''
      },
      userRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入有效的邮箱地址', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        passwordConfirm: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: this.validatePasswordConfirm, trigger: 'blur' }
        ]
      },
      // 媒体库相关数据
      mediaList: [],
      totalMedia: 0,
      mediaCurrentPage: 1,
      mediaPageSize: 10,
      mediaSearchQuery: '',
      showUploadDialog: false,
      mediaForm: {
        description: ''
      },
      mediaRules: {
        // 移除file字段的表单验证，因为我们使用自定义的文件处理逻辑
        description: []
      },
      mediaFileList: [],
      mediaFile: null,
      selectedMedia: null,
      currentOperation: null,
      showMediaSelectDialog: false,
      // 轮播图管理相关数据
      bannersList: [],
      totalBanners: 0,
      bannersCurrentPage: 1,
      bannersPageSize: 10,
      bannersSearchQuery: '',
      bannersStatusFilter: '',
      showAddBannerDialog: false,
      bannerForm: {
        title: '',
        subtitle: '',
        description: '',
        image: '',
        order: 0,
        status: 'active'
      },
      bannerRules: {
        title: [
          { required: true, message: '请输入轮播图标题', trigger: 'blur' },
          { max: 200, message: '轮播图标题不能超过200个字符', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '请选择轮播图图片', trigger: 'blur' }
        ],
        order: [
          { required: true, message: '请输入排序值', trigger: 'blur' },
          { type: 'number', message: '排序值必须是数字', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    // 组件创建时获取数据
    this.initData();
  },
  methods: {
    async initData() {
      try {
        // 并行获取所有数据
        await Promise.all([
          this.fetchNews(),
          this.fetchUsers(),
          this.fetchMedia(),
          this.fetchBanners()
        ]);
      } catch (error) {
        console.error('初始化数据失败:', error);
        // 数据获取失败时，保留默认数据，确保页面仍能正常显示
        this.$message.error('部分数据获取失败，显示默认数据');
      }
    },
    getPageTitle() {
      switch (this.activeMenu) {
        case 'news':
          return '新闻管理';
        case 'banners':
          return '轮播图管理';
        case 'media':
          return '媒体库管理';
        case 'users':
          return '用户管理';
        case 'settings':
          return '系统设置';
        default:
          return '管理后台';
      }
    },
    // 权限管理相关方法
    async manageUserRoles(user) {
      this.currentUser = { ...user };
      this.showRoleManagementDialog = true;
      
      try {
        // 获取所有角色
        const rolesData = await roleAPI.getAllRoles();
        if (rolesData.success) {
          this.allRoles = rolesData.data;
        } else {
          this.$message.error('获取角色列表失败');
          return;
        }
        
        // 获取用户当前角色
        const userRolesData = await roleAPI.getUserRoles(user.id);
        if (userRolesData.success) {
          this.userRoles = userRolesData.data;
          // 将用户角色转换为id数组，用于checkbox-group的v-model
          this.selectedRoles = this.userRoles.map(role => role.id);
        } else {
          this.$message.error('获取用户角色失败');
          return;
        }
      } catch (error) {
        console.error('获取角色信息失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    },
    
    async saveUserRoles() {
      if (this.selectedRoles.length === 0) {
        this.$message.error('请为用户选择至少一个角色');
        return;
      }
      
      try {
        const data = await roleAPI.updateUserRoles(this.currentUser.id, this.selectedRoles);
        if (data.success) {
          this.$message.success('权限保存成功');
          this.showRoleManagementDialog = false;
          // 重新获取用户列表，更新角色信息
          this.fetchUsers();
          // 重置权限管理相关状态
          this.resetRoleManagement();
        } else {
          this.$message.error(data.message || '权限保存失败');
        }
      } catch (error) {
        console.error('保存用户角色失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    },
    
    // 重置权限管理相关状态
    resetRoleManagement() {
      this.currentUser = null;
      this.userRoles = [];
      this.selectedRoles = [];
    },
    
    // 格式化日期
    formatDate(row, column, cellValue) {
      return new Date(cellValue).toLocaleString();
    },
    async fetchNews() {
      // 调用后端API获取新闻列表
      try {
        const data = await newsAPI.getNewsList(this.currentPage, this.pageSize, this.statusFilter, this.searchQuery);
        if (data.success) {
          this.newsList = data.data.newsList;
          this.totalNews = data.data.pagination.total;
        } else {
          this.$message.error(data.message || '获取新闻列表失败');
        }
      } catch (error) {
        console.error('获取新闻列表失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchNews();
    },
    editNews(news) {
      this.newsForm = { ...news };
      this.showAddNewsDialog = true;
    },
    async deleteNews(id) {
      this.$confirm('确定要删除这条新闻吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const data = await newsAPI.deleteNews(id);
          if (data.success) {
            this.$message.success('删除成功');
            this.fetchNews(); // 重新获取新闻列表
          } else {
            this.$message.error(data.message || '删除失败');
          }
        } catch (error) {
          console.error('删除新闻失败:', error);
          this.$message.error('服务器错误，请稍后重试');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    selectNewsImage() {
      // 显示媒体选择对话框
      this.showMediaSelectDialog = true;
      // 获取媒体列表
      this.fetchMedia();
    },
    removeNewsImage() {
      this.newsForm.image = '';
    },
    selectMediaForNews(media) {
      this.selectedMedia = media;
    },
    confirmMediaSelection() {
      if (this.selectedMedia) {
        this.newsForm.image = this.selectedMedia.url;
        this.showMediaSelectDialog = false;
        this.selectedMedia = null;
        this.$message.success('图片选择成功');
      }
    },
    submitNewsForm() {
      this.$refs.newsForm.validate(async (valid) => {
        if (valid) {
          const isEdit = this.newsForm.id;
          try {
            let data;
            
            if (isEdit) {
              data = await newsAPI.updateNews(this.newsForm.id, this.newsForm);
            } else {
              data = await newsAPI.createNews(this.newsForm);
            }
            
            if (data.success) {
              this.$message.success(isEdit ? '新闻更新成功' : '新闻添加成功');
              this.showAddNewsDialog = false;
              this.$refs.newsForm.resetFields();
              this.fetchNews(); // 重新获取新闻列表
            } else {
              this.$message.error(data.message || (isEdit ? '新闻更新失败' : '新闻添加失败'));
            }
          } catch (error) {
            console.error(isEdit ? '更新新闻失败:' : '添加新闻失败:', error);
            this.$message.error('服务器错误，请稍后重试');
          }
        }
      });
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        localStorage.removeItem('token');
        this.$router.push('/login');
      }).catch(() => {
        // 取消退出
      });
    },
    // 用户管理相关方法
    validatePasswordConfirm(rule, value, callback) {
      if (value !== this.userForm.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },
    async fetchUsers() {
      try {
        const data = await userAPI.getUserList(this.usersCurrentPage, this.usersPageSize, this.usersSearchQuery);
        if (data.success) {
          this.usersList = data.data.list || [];
          this.totalUsers = data.data.total || 0;
        } else {
          this.$message.error(data.message || '获取用户列表失败');
        }
      } catch (error) {
        console.error('获取用户列表失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    },
    handleUsersPageChange(page) {
      this.usersCurrentPage = page;
      this.fetchUsers();
    },
    editUser(user) {
      this.userForm = { ...user };
      delete this.userForm.password; // 不显示密码
      delete this.userForm.passwordConfirm;
      this.showAddUserDialog = true;
    },
    async deleteUser(id) {
      this.$confirm('确定要删除这个用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const data = await userAPI.deleteUser(id);
          if (data.success) {
            this.$message.success('删除成功');
            this.fetchUsers(); // 重新获取用户列表
          } else {
            this.$message.error(data.message || '删除失败');
          }
        } catch (error) {
          console.error('删除用户失败:', error);
          this.$message.error('服务器错误，请稍后重试');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    submitUserForm() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          try {
            const isEdit = this.userForm.id;
            let data;
            
            if (isEdit) {
              // 编辑用户时，如果没有修改密码，不发送密码字段
              const userData = { ...this.userForm };
              if (!userData.password) {
                delete userData.password;
                delete userData.passwordConfirm;
              }
              data = await userAPI.updateUser(userData.id, userData);
            } else {
              data = await userAPI.createUser(this.userForm);
            }
            
            if (data.success) {
              this.$message.success(this.userForm.id ? '用户更新成功' : '用户添加成功');
              this.showAddUserDialog = false;
              this.$refs.userForm.resetFields();
              this.fetchUsers(); // 重新获取用户列表
            } else {
              this.$message.error(data.message || (this.userForm.id ? '用户更新失败' : '用户添加失败'));
            }
          } catch (error) {
            console.error(this.userForm.id ? '更新用户失败:' : '添加用户失败:', error);
            this.$message.error('服务器错误，请稍后重试');
          }
        }
      });
    },
    // 媒体库相关方法
    async fetchMedia() {
      try {
        const data = await mediaAPI.getMediaList(this.mediaCurrentPage, this.mediaPageSize, this.mediaSearchQuery);
        if (data.success) {
          this.mediaList = data.data.list || [];
          this.totalMedia = data.data.total || 0;
        } else {
          this.$message.error(data.message || '获取媒体列表失败');
        }
      } catch (error) {
        console.error('获取媒体列表失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    },
    handleMediaPageChange(page) {
      this.mediaCurrentPage = page;
      this.fetchMedia();
    },
    selectMedia(media) {
      this.selectedMedia = media;
      this.$message.success('媒体已选择');
      
      // 如果当前是为新闻选择图片，返回到新闻编辑页面
      if (this.currentOperation && this.currentOperation.type === 'selectNewsImage') {
        this.newsForm = this.currentOperation.newsForm;
        this.newsForm.image = media.url;
        this.activeMenu = 'news';
        this.currentOperation = null;
        this.showAddNewsDialog = true;
      }
      // 如果当前是为轮播图选择图片，返回到轮播图编辑页面
      else if (this.currentOperation && this.currentOperation.type === 'selectBannerImage') {
        this.bannerForm = this.currentOperation.bannerForm;
        this.bannerForm.image = media.url;
        this.activeMenu = 'banners';
        this.currentOperation = null;
        this.showAddBannerDialog = true;
      }
    },
    // 轮播图相关方法
    async fetchBanners() {
      try {
        const data = await bannerAPI.getBannerList(this.bannersCurrentPage, this.bannersPageSize, this.bannersStatusFilter, this.bannersSearchQuery);
        if (data.success) {
          this.bannersList = data.data.banners || [];
          this.totalBanners = data.data.pagination?.total || 0;
        } else {
          this.$message.error(data.message || '获取轮播图列表失败');
        }
      } catch (error) {
        console.error('获取轮播图列表失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    },
    handleBannersPageChange(page) {
      this.bannersCurrentPage = page;
      this.fetchBanners();
    },
    editBanner(banner) {
      this.bannerForm = { ...banner };
      this.showAddBannerDialog = true;
    },
    async deleteBanner(id) {
      this.$confirm('确定要删除这个轮播图吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const data = await bannerAPI.deleteBanner(id);
          if (data.success) {
            this.$message.success('删除成功');
            this.fetchBanners(); // 重新获取轮播图列表
          } else {
            this.$message.error(data.message || '删除失败');
          }
        } catch (error) {
          console.error('删除轮播图失败:', error);
          this.$message.error('服务器错误，请稍后重试');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    selectBannerImage() {
      // 跳转到媒体库页面选择图片
      this.activeMenu = 'media';
      // 记录当前操作的是轮播图图片选择
      this.currentOperation = {
        type: 'selectBannerImage',
        bannerForm: this.bannerForm
      };
    },
    removeBannerImage() {
      this.bannerForm.image = '';
    },
    submitBannerForm() {
      this.$refs.bannerForm.validate(async (valid) => {
        if (valid) {
          const isEdit = this.bannerForm.id;
          try {
            let data;
            
            if (isEdit) {
              data = await bannerAPI.updateBanner(this.bannerForm.id, this.bannerForm);
            } else {
              data = await bannerAPI.createBanner(this.bannerForm);
            }
            
            if (data.success) {
              this.$message.success(isEdit ? '轮播图更新成功' : '轮播图添加成功');
              this.showAddBannerDialog = false;
              this.$refs.bannerForm.resetFields();
              this.fetchBanners(); // 重新获取轮播图列表
            } else {
              this.$message.error(data.message || (isEdit ? '轮播图更新失败' : '轮播图添加失败'));
            }
          } catch (error) {
            console.error(isEdit ? '更新轮播图失败:' : '添加轮播图失败:', error);
            this.$message.error('服务器错误，请稍后重试');
          }
        }
      });
    },
    async deleteMedia(id) {
      this.$confirm('确定要删除这个媒体文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const data = await mediaAPI.deleteMedia(id);
          if (data.success) {
            this.$message.success('删除成功');
            this.fetchMedia(); // 重新获取媒体列表
          } else {
            this.$message.error(data.message || '删除失败');
          }
        } catch (error) {
          console.error('删除媒体失败:', error);
          this.$message.error('服务器错误，请稍后重试');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    // 审核状态相关方法
    getStatusText(status) {
      const statusMap = {
        draft: '草稿',
        pending_review: '待审核',
        published: '已发布',
        rejected: '已拒绝'
      };
      return statusMap[status] || status;
    },
    
    getStatusTagType(status) {
      const typeMap = {
        draft: 'info',
        pending_review: 'warning',
        published: 'success',
        rejected: 'danger'
      };
      return typeMap[status] || 'info';
    },
    
    // 提交审核
    async submitForReview(id) {
      try {
        const data = await newsAPI.updateNewsStatus(id, 'pending_review');
        if (data.success) {
          this.$message.success('提交审核成功');
          this.fetchNews();
        } else {
          this.$message.error(data.message || '提交审核失败');
        }
      } catch (error) {
        console.error('提交审核失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    },
    
    // 审核通过
    async approveNews(id) {
      try {
        const data = await newsAPI.updateNewsStatus(id, 'published');
        if (data.success) {
          this.$message.success('审核通过成功');
          this.fetchNews();
        } else {
          this.$message.error(data.message || '审核通过失败');
        }
      } catch (error) {
        console.error('审核通过失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    },
    
    // 拒绝审核
    async rejectNews(id) {
      try {
        const data = await newsAPI.updateNewsStatus(id, 'rejected');
        if (data.success) {
          this.$message.success('拒绝成功');
          this.fetchNews();
        } else {
          this.$message.error(data.message || '拒绝失败');
        }
      } catch (error) {
        console.error('拒绝失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    },
    handleUpload(file) {
      // 这里只是保存文件，实际上传在submitMediaUpload中处理
      this.mediaFile = file.file;
    },
    handleFileChange(file, fileList) {
      this.mediaFileList = fileList.slice(-1); // 只保留最后一个文件
      if (file.raw) {
        this.mediaFile = file.raw;
      }
    },
    handleFileRemove(file, fileList) {
      this.mediaFileList = fileList;
      this.mediaFile = null;
    },
    async submitMediaUpload() {
      // 从mediaFileList中获取文件，或者使用this.mediaFile
      let fileToUpload = this.mediaFile;
      
      // 如果mediaFile为空，尝试从mediaFileList中获取文件
      if (!fileToUpload && this.mediaFileList.length > 0) {
        // 获取最后一个文件
        fileToUpload = this.mediaFileList[this.mediaFileList.length - 1].raw;
      }
      
      if (!fileToUpload) {
        this.$message.error('请选择要上传的文件');
        return;
      }
      
      try {
        const data = await mediaAPI.uploadMedia(fileToUpload);
        if (data.success) {
          this.$message.success('上传成功');
          this.showUploadDialog = false;
          this.mediaFileList = [];
          this.mediaFile = null;
          this.fetchMedia(); // 重新获取媒体列表
        } else {
          this.$message.error(data.message || '上传失败');
        }
      } catch (error) {
        console.error('上传媒体失败:', error);
        this.$message.error('服务器错误，请稍后重试');
      }
    }
  }
};
</script>

<style scoped>
.role-checkbox {
  display: block;
  margin-bottom: 10px;
}

.role-description {
  margin-top: 10px;
  color: #909399;
  font-size: 14px;
}

.admin-container {
  display: flex;
  height: 100%;
  background-color: #f5f7fa;
}

/* 侧边栏样式 */
.sidebar {
  width: 250px;
  background-color: #304156;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #40556f;
}

.sidebar-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.sidebar-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item a {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: #bfcbd9;
  text-decoration: none;
  transition: all 0.3s ease;
}

.nav-item a:hover,
.nav-item.active a {
  background-color: #263445;
  color: #409eff;
}

.nav-item i {
  margin-right: 10px;
  font-size: 16px;
}

.nav-item span {
  font-size: 14px;
}

.sidebar-footer {
  margin-top: auto;
  padding: 20px;
  border-top: 1px solid #40556f;
}

.logout-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background-color: #40556f;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background-color: #50657f;
}

.logout-btn i {
  margin-right: 8px;
}

/* 主内容区域样式 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-header {
  background-color: #fff;
  padding: 0 30px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.main-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #304156;
}

.user-info {
  display: flex;
  align-items: center;
}

.username {
  font-size: 14px;
  color: #304156;
}

.content-wrapper {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

/* 新闻管理页面样式 */
.news-management {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #304156;
}

.search-filter {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

.search-input {
  width: 300px;
}

.filter-select {
  width: 150px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

/* 图片上传和预览样式 */
.image-upload-section {
  display: flex;
  align-items: center;
}

.image-preview {
  margin-top: 10px;
}

.image-preview img {
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

/* 媒体库相关样式 */
.media-management {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar {
    width: 200px;
  }
  
  .search-filter {
    flex-direction: column;
  }
  
  .search-input,
  .filter-select {
    width: 100%;
  }
  
  .image-upload-section {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .image-upload-section .el-button {
    margin-left: 0 !important;
    margin-top: 10px;
  }
}

/* 媒体选择弹窗样式 */
.media-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
}

.media-item {
  position: relative;
  border: 2px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.media-item:hover {
  border-color: #409eff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.media-item-selected {
  border-color: #67c23a;
  box-shadow: 0 0 0 2px rgba(103, 194, 58, 0.3);
}

.media-item-name {
  padding: 8px;
  font-size: 12px;
  color: #606266;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
}

.media-item-check {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  background-color: #67c23a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}

.empty-media {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}
</style>